
function addToGroupsDialog () {
  return {
    restrict: 'E',
    templateUrl: '/core/dialogs/add-to-groups/add-to-groups-dialog.html?$$REVISION$$'
  }
}
export { addToGroupsDialog }
